export function getTenantInvitationStage(currentUser, invitation) {
  if (!currentUser) return "account_form";
  if (invitation?.signedInUserMatchesInvitation !== true) {
    return "account_mismatch";
  }
  return currentUser.emailVerified ?
    "accepting_invitation" : "email_verification_required";
}

export function isInvitationEmailMismatchError(error) {
  return error?.details?.reason === "invitation_email_mismatch";
}
